const langAdminInvestors = {
	keywords: {
		tag: 'admin.investors.keywords',
		fr: 'Mots clés',
		en: 'Keywords',
	},
	display_deleted_accounts: {
		tag: 'admin.investors.display_deleted_accounts',
		fr: 'Afficher les comptes supprimés',
		en: 'Display deleted accounts',
	},
	display_disabled_accounts: {
		tag: 'admin.investors.display_disabled_accounts',
		fr: 'Afficher les comptes inactifs',
		en: 'Display disabled accounts',
	},
	title: {
		tag: 'admin.investors.title',
		fr: 'Liste des investisseurs',
		en: 'Investors list',
	},
	table_header_open: {
		tag: 'admin.investors.table_header_open',
		fr: 'Ouvrir',
		en: 'Open',
	},
	table_header_groups: {
		tag: 'admin.investors.table_header_groups',
		fr: 'Groupes',
		en: 'Groups',
	},
	table_header_firstname: {
		tag: 'admin.investors.table_header_firstname',
		fr: 'Prénom',
		en: 'Firstname',
	},
	table_header_lastname: {
		tag: 'admin.investors.table_header_lastname',
		fr: 'Nom',
		en: 'Lastname',
	},
	table_header_login: {
		tag: 'admin.investors.table_header_login',
		fr: 'Login',
		en: 'Login',
	},
	table_header_email: {
		tag: 'admin.investors.table_header_email',
		fr: 'E-mail',
		en: 'Email',
	},
	table_header_lang: {
		tag: 'admin.investors.table_header_lang',
		fr: 'Langue',
		en: 'Lang',
	},
	table_header_okta_sync: {
		tag: 'admin.investors.table_header_okta_sync',
		fr: 'Sync. Okta',
		en: 'Okta sync.',
	},
	table_header_active: {
		tag: 'admin.investors.table_header_active',
		fr: 'Actif',
		en: 'Active',
	},
	table_header_created_at: {
		tag: 'admin.investors.table_header_created_at',
		fr: 'Créé le',
		en: 'Created at',
	},
	table_header_deleted_at: {
		tag: 'admin.investors.table_header_deleted_at',
		fr: 'Supprimé le',
		en: 'Deleted at',
	},
};

export default langAdminInvestors;
